import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { Button } from "../../utils/Utils";
import { Background } from "../../Background";

export class DifficultySelectionScene extends Phaser.Scene {

    public static currentInstance: DifficultySelectionScene;
    
    constructor() {

        super("DifficultySelectionScene");
        
        DifficultySelectionScene.currentInstance = this;
    }

    public create(): void {

        GameManager.setCurrentScene(this);

        const tmpBackground = this.add.graphics();
        tmpBackground.fillStyle(0xffffff);
        tmpBackground.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        let background = new Background(this);
        this.add.existing(background);

        const backButton = new Button(this, 60, 60 * GameVars.scaleY, "texture_atlas_1", "btn_back", "btn_back_hover");
        backButton.scaleY = GameVars.scaleY;
        backButton.onUp(this.onClickBack, this);
        this.add.existing(backButton);

        const scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);
        scaledItemsContainer.scaleY = GameVars.scaleY;

        const sceneTitleLabel = new Phaser.GameObjects.Image(this, 0, -300, "texture_atlas_1", "txt_game_mode");
        scaledItemsContainer.add(sceneTitleLabel);
        
        const easyButton = new Button(this, -220, 0, "texture_atlas_1", "btn_lvl_easy", "btn_lvl_easy_hover");
        easyButton.onUp(this.onEasyLevelsSelected, this);
        scaledItemsContainer.add(easyButton);

        const mediumButton = new Button(this, 0, 0, "texture_atlas_1", "btn_lvl_medium", "btn_lvl_medium_hover");
        mediumButton.onUp(this.onMediumLevelsSelected, this);
        scaledItemsContainer.add(mediumButton);

        const difficultButton = new Button(this, 220, 0, "texture_atlas_1", "btn_lvl_hard", "btn_lvl_hard_hover");
        difficultButton.onUp(this.onDifficultLevelsSelected, this);
        scaledItemsContainer.add(difficultButton);

        const easyLevelsLabel = this.add.text(easyButton.x, 80, GameVars.gameData.achievedEasyLevel + "/" + GameConstants.TOTAL_EASY_LEVELS, {fontFamily: "Bubblegum", fontSize: "50px", color: "#09808D"});
        easyLevelsLabel.setOrigin(.5);
        scaledItemsContainer.add(easyLevelsLabel);

        const mediumLevelsLabel = this.add.text(mediumButton.x, 80, GameVars.gameData.achievedMediumLevel + "/" + GameConstants.TOTAL_EASY_LEVELS, {fontFamily: "Bubblegum", fontSize: "50px", color: "#09808D"});
        mediumLevelsLabel.setOrigin(.5);
        scaledItemsContainer.add(mediumLevelsLabel);

        const difficultLevelsLabel = this.add.text(difficultButton.x, 80, GameVars.gameData.achievedDifficultLevel + "/" + GameConstants.TOTAL_EASY_LEVELS, {fontFamily: "Bubblegum", fontSize: "50px", color: "#09808D"});
        difficultLevelsLabel.setOrigin(.5);
        scaledItemsContainer.add(difficultLevelsLabel);

        this.cameras.main.fadeIn(300, 255, 255, 255);
    }

    public onEasyLevelsSelected(): void {

        this.cameras.main.fadeOut(300, 255, 255, 255);

        this.cameras.main.once("camerafadeoutcomplete", function (): void {
            GameManager.enterDifficultySelectionScene();
        });
        
        GameManager.enterLevelSelectionScene(GameConstants.DIFFICULTY_EASY);
    }

    public onMediumLevelsSelected(): void {

        this.cameras.main.fadeOut(300, 255, 255, 255);

        this.cameras.main.once("camerafadeoutcomplete", function (): void {
            GameManager.enterLevelSelectionScene(GameConstants.DIFFICULTY_NORMAL);
        });
    }

    public onDifficultLevelsSelected(): void {
        
        this.cameras.main.fadeOut(300, 255, 255, 255);

        this.cameras.main.once("camerafadeoutcomplete", function (): void {
            GameManager.enterLevelSelectionScene(GameConstants.DIFFICULTY_HERO);
        });
    }

    private onClickBack(): void {

        this.cameras.main.fadeOut(300, 255, 255, 255);

        this.cameras.main.once("camerafadeoutcomplete", function (): void {
            GameManager.enterSplashScene();
        });
    }
}
